export const ENTRY_FORM_ROUTES: {
	[key: string]: {
		path: string;
		index: number;
	};
} = {
	"basic-info": {
		path: "basic-info",
		index: 0,
	},
	"additional-info": {
		path: "additional-info",
		index: 1,
	},
	credits: {
		path: "credits",
		index: 2,
	},
	media: {
		path: "media",
		index: 3,
	},
	executions: {
		path: "executions",
		index: 4,
	},
	review: {
		path: "review",
		index: 5,
	},
};
